<!--  -->
<template>
  <div class="page">
    <div
      class="item"
      v-for="(item, index) in list"
      :key="index"
      @click="buy(item.id)"
    >
      <div class="ticket">
        <div class="ticket-left">
          <a-avatar shape="square" :size="120" :src="item.logo" />
        </div>
        <div class="ticket-right">
          <p>
            <b>{{ item.ticket }}</b>
          </p>
          <p>{{ item.spot_type }}</p>
          <p class="price">￥{{ item.price }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTickets } from "@/api/api-ticket.js";
import { Modal } from "ant-design-vue";
export default {
  components: {},
  data() {
    return {
      list: [],
      system_notice: "",
      open_system_notice: null
    };
  },
  computed: {},
  watch: {},
  methods: {
    getList() {
      getTickets().then(res => {
        let list = [];
        res.list.forEach(element => {
          list.push(...element.children);
        });
        this.list = list;
        this.system_notice = res.system_notice;
        this.open_system_notice = res.open_system_notice;
        sessionStorage.setItem("desc", res.desc);
        sessionStorage.setItem("open_health_notice", res.open_health_notice);
        sessionStorage.setItem("health_notice", res.health_notice);
        this.$emit("getDetails");
      });
    },
    buy(id) {
      let that = this;
      if (this.open_system_notice == 1) {
        Modal.warning({
          title: "提示",
          content: that.system_notice,
          centered: true,
          okText: "确定",
          onOk() {
            that.$emit("selectTicket", id);
          }
        });
      } else {
        that.$emit("selectTicket", id);
      }
    }
  },
  created() {
    this.getList();
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  height: 500px;
  overflow-y: scroll;
  padding: 10px;
}

.item {
  width: 49%;
  height: 150px;
  float: left;
  cursor: pointer;
  border-radius: 4px;
  background-color: #fafafa;
  margin-bottom: 10px;
  transition: all 0.3s;
  &:hover {
    box-shadow: 0 1px 5px 0 #cccbcb;
    transform: translate(1px, -1px);
  }
}

.item:nth-child(odd) {
  margin-right: 2%;
}
.ticket {
  display: flex;
  padding: 15px;
  //   align-items: center;
}
.ticket-right {
  padding-top: 10px;
  margin-left: 40px;
}
.ticket-right p {
  text-align: left;
  &:first-child {
    b {
      font-size: 20px;
    }
  }
  &.price {
    color: orange;
    font-size: 18px;
    font-weight: 700;
  }
}
</style>
